import { GetLoginURLWithRedirect } from './errorUrls.types'

export const getLoginURLWithRedirect: GetLoginURLWithRedirect = (loginURL, returnUrl) => (
  (returnUrl !== undefined)
    ? `${loginURL}?returnURL=${encodeURIComponent(returnUrl)}`
    : loginURL
)
